import { render, staticRenderFns } from "./LopdTable.vue?vue&type=template&id=5124dcf7&"
import script from "./LopdTable.vue?vue&type=script&lang=js&"
export * from "./LopdTable.vue?vue&type=script&lang=js&"
import style0 from "./LopdTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports